import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './toggle.css'

const Toggle = ({ checked, id, small, onChange }) => (
  <div styleName={small ? 'toggle-small' : 'toggle-regular'}>
    <input
      id={id}
      styleName="checkbox"
      type="checkbox"
      checked={checked}
      onChange={onChange}
    />
    <label
      htmlFor={id}
      styleName={checked ? 'label-checked' : 'label-unchecked'}
    >
      <span styleName={checked ? 'track-checked' : 'track-unchecked'} />
    </label>
  </div>
)

Toggle.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.string,
  small: PropTypes.bool,
  onChange: PropTypes.func,
}

export default CSSModules(Toggle, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/toggle/toggle.js
 **/